import Bannerman from './bannerman';

export default Bannerman;
